import React from 'react';
import styled from 'styled-components';

import List from 'shared/components/List';
import Source from 'shared/components/Source';

import FlowLabeledContent from '../FlowLabeledContent';
import WorkflowFlowBox from '../WorkflowFlowBox';

import { WorkflowSourceBoxProps } from './types';

const SOURCE_LIST_ICON_CLASS_NAME = 'source-list__icon';

const StyledSourceTitle = styled.span`
  color: #8d9199;
  font-size: 1rem;
`;

const StyledList = styled(List)`
  max-width: 25rem;
`;

const StyledSourceListTitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.416666667rem;
`;

const StyledSourceListItem = styled.div`
  display: flex;
  align-items: center;
  padding: 0 0.5rem;

  &:not(:last-child) {
    margin-bottom: 0.333333333rem;
  }
`;

const StyledSource = styled(Source)`
  min-width: 0;
  flex: 1;
  margin-right: 3rem;

  & .${SOURCE_LIST_ICON_CLASS_NAME} {
    margin-right: 0.166666667rem;
  }
`;

const StyledWeight = styled.span``;

// This component corresponds to the source icons rendered when the workflow item remains closed.
const StyledSourceIcon = styled(Source)`
  &:not(:last-child) {
    margin-right: 0.333333333rem;
  }
`;

const renderSourceList = (sources: WorkflowSourceBoxProps['sources']) => {
  const title = (
    <StyledSourceListTitleContainer>
      <StyledSourceTitle>Source</StyledSourceTitle>
      <StyledSourceTitle>Weight</StyledSourceTitle>
    </StyledSourceListTitleContainer>
  );

  return (
    <StyledList
      title={title}
      items={sources}
      renderItem={(source) => (
        <StyledSourceListItem>
          <StyledSource source={source} iconClassName={SOURCE_LIST_ICON_CLASS_NAME} />
          <StyledWeight>{source.weight}</StyledWeight>
        </StyledSourceListItem>
      )}
    />
  );
};

const renderSourceIcons = (sources: WorkflowSourceBoxProps['sources']) => {
  const sourceIcons = sources.map((source) => (
    <StyledSourceIcon
      key={source.name}
      source={source}
      withLabel={false}
    />
  ));

  return (
    <FlowLabeledContent label='Sources'>
      {sourceIcons}
    </FlowLabeledContent>
  );
};

const WorkflowSourceBox = ({
  isOpen,
  sources,
}: WorkflowSourceBoxProps) => (
  <WorkflowFlowBox
    isOpen={isOpen}
    contentWhenIsOpen={renderSourceList(sources)}
    contentWhenIsClosed={renderSourceIcons(sources)}
  />
);

export default WorkflowSourceBox;
